import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "wrapper": "pbui-cNlz7",
  "image": "pbui-xLB3m",
  "content": "pbui-EEVVa",
  "title": "pbui-C2lLd",
  "description": "pbui-jMxoM",
  "icon__time": "pbui-SG5q-",
  "icon": "pbui-eBskg",
  "time": "pbui-5LI6D"
};
var NewsCard = function NewsCard(_ref) {
  var author = _ref.author,
    description = _ref.description,
    image = _ref.image,
    imageAltText = _ref.imageAltText,
    time = _ref.time,
    title = _ref.title;
  var wrapperClasses = clsx(styles.wrapper);
  var imageClasses = clsx(styles.image);
  var contentClasses = clsx(styles.content);
  var titleClasses = clsx(styles.title);
  var descriptionClasses = clsx(styles.description);
  var iconTimeClasses = clsx(styles.icon__time);
  var iconClasses = clsx(styles.icon);
  var timeClasses = clsx(styles.time);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperClasses,
    children: [/*#__PURE__*/_jsx("img", {
      alt: imageAltText || title,
      src: image || '/assets/images/placeholder.png',
      className: imageClasses
    }), title && /*#__PURE__*/_jsxs("div", {
      className: contentClasses,
      children: [/*#__PURE__*/_jsx("h2", {
        className: titleClasses,
        children: title
      }), description && /*#__PURE__*/_jsx("p", {
        className: descriptionClasses,
        children: description
      }), time && /*#__PURE__*/_jsxs("div", {
        className: iconTimeClasses,
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faClock,
          size: "sm",
          className: iconClasses
        }), /*#__PURE__*/_jsx("p", {
          className: timeClasses,
          children: time
        }), author && /*#__PURE__*/_jsxs("p", {
          className: timeClasses,
          children: [" - ", author]
        })]
      })]
    })]
  });
};
export default NewsCard;